<template>
  <sc-page-base :title="title" :loading="loading">
    <sc-grid
      :name="$options.name"
      :data="tableData.items"
      :total="tableData.total"
      :default-filters="defaultFilters"
      default-sort-column="id"
      default-sort-direction="ascending"
      @submit="config"
      @pagination="config"
      @sorting="config"
    >

      <template slot="filters" slot-scope="{ filters }">
        <sc-report-delivered-provider-filters
          :filters="filters"
          :maxDate="startLimit"
          :limitMinDate="endLimit"
        />
      </template>

      <template slot="after-filters" v-if="tableData.total">
        <div class="box">
          <sc-report-delivered-provider-chart />
        </div>
      </template>

      <template slot="before-table" v-if="tableData.total">
        <div class="buttons">
          <sc-button
            theme="primary"
            :loading="exportLoading"
            text="Exportar para o Excel"
            icon="file-excel"
            @click="exportDeliveredProviderReport(reportConfig)"
          />
        </div>
      </template>

      <template slot="table-columns" slot-scope="{ props }">
        <sc-table-column field="invoices" label="Número do Pedido" sortable>
          {{ props.row.order_number }}
        </sc-table-column>

        <sc-table-column field="" label="Número da Nota" sortable>
          {{ listInvoiceNumbers(props.row.invoices) }}
        </sc-table-column>

        <sc-table-column
          field="end_customer_firstname"
          label="Nome do Cliente"
          sortable
        >
          {{
            getFullName(
              props.row.shipping_first_name,
              props.row.shipping_last_name
            )
          }}
        </sc-table-column>

        <sc-table-column
          field="logistic_provider_name"
          label="Provedor Logístico"
          sortable
        >
          {{ props.row.logistic_provider_name }}
        </sc-table-column>

        <sc-table-column
          field="delivery_method_name"
          label="Método de Entrega"
          sortable
        >
          {{ props.row.delivery_method_name }}
        </sc-table-column>

        <sc-table-column
          field="estimated_delivery_date_iso"
          label="Data de Entrega Estimada Cliente"
          sortable
        >
          {{ props.row.estimated_delivery_date_iso | date("DD/MM/YYYY") }}
        </sc-table-column>

        <sc-table-column
          field="estimated_delivery_date_lp_iso"
          label="Data de Entrega Estimada Transp."
          sortable
        >
          {{ props.row.estimated_delivery_date_lp_iso | date("DD/MM/YYYY") }}
        </sc-table-column>

        <sc-table-column
          field="delivered_date_iso"
          label="Data de entrega"
          sortable
        >
          {{ props.row.delivered_date | date("DD/MM/YYYY") }}
        </sc-table-column>

        <sc-table-column
          field="on_time_sort"
          label="Performance Cliente"
          sortable
        >
          {{ props.row.on_time_localized }}
        </sc-table-column>

        <sc-table-column
          field="on_time_lp_sort"
          label="Performance Transp."
          sortable
        >
          {{ props.row.on_time_lp_localized }}
        </sc-table-column>

        <sc-table-column field="cep_state" label="UF" sortable>
          {{ props.row.shipping_state }}
        </sc-table-column>

        <sc-table-column field="created_at_iso" label="Criado em" sortable>
          {{ props.row.created_at_date_time_iso | date("DD/MM/YYYY") }}
        </sc-table-column>
      </template>
    </sc-grid>
  </sc-page-base>
</template>

<script>
import {
  ScPageBase,
  ScGrid,
  ScIcon,
  ScButton,
  ScTableColumn,
} from '@intelipost-js/secure-components';

import { createNamespacedHelpers } from 'vuex';
import ScReportDeliveredProviderChart from './components/sc-report-delivered-provider-chart/ScReportDeliveredProviderChart';
import ScReportDeliveredProviderFilters from './components/sc-report-delivered-provider-filters/ScReportDeliveredProviderFilters';
import Constants from '../../../config';

const { mapActions, mapState } = createNamespacedHelpers('analytic/deliveredProvider');

export default {
  name: 'page-report-delivered-provider',
  data() {
    return {
      title: 'Pedidos Despachados',
      reportConfig: {},
      defaultFilters: null,
      startLimit: null,
      endLimit: null,
    };
  },
  created() {
    const today = new Date();
    this.generateDateRange(today, Constants.reports_range_days);
  },
  computed: {
    ...mapState(['loading', 'exportLoading', 'tableData', 'chartData']),
  },
  methods: {
    ...mapActions([
      'generateDeliveredProviderTable',
      'exportDeliveredProviderReport',
    ]),
    formatDate(time) {
      const date = new Date(time);
      return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
        .toISOString()
        .split('T')[0];
    },

    generateDateRange(start, rangeInDays) {
      const dayInMiliseconds = 86400000;
      const rangeInMiliseconds = dayInMiliseconds * rangeInDays;
      this.startLimit = start;
      this.endLimit = new Date(start.getTime() - rangeInMiliseconds);
      this.defaultFilters = {
        dateRange: {
          start: this.formatDate(this.startLimit.getTime()),
          end: this.formatDate(this.startLimit.getTime()),
        },
      };
    },
    config(config) {
      this.reportConfig = config;
      this.generateDeliveredProviderTable(config);
    },
    getFullName(firstName, lastName) {
      return `${firstName || ''} ${lastName || ''}`;
    },
    listInvoiceNumbers(invoices) {
      return invoices
        .filter(invoice => invoice.invoice_number && invoice.invoice_series)
        .map(invoice => `${invoice.invoice_number}-${invoice.invoice_series}`)
        .join(', ');
    },
  },
  components: {
    ScPageBase,
    ScGrid,
    ScIcon,
    ScButton,
    ScTableColumn,
    ScReportDeliveredProviderChart,
    ScReportDeliveredProviderFilters,
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/delivered-provider/PageReportDeliveredProvider.vue?e3e95e70